
import { UserMe } from './../../auth/_models/user-me';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from './../../auth/_services';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() exibeMenu: boolean;
  title = 'plataforma';
  currentUser: UserMe;
  expires: number;
  isAdmin = false;
  isEditor = false;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    public translate: TranslateService
  ) {
    translate.addLangs(['pt-br', 'en']);
    translate.setDefaultLang('pt-br');
    translate.use('pt-br');
  }

  ngOnInit() {
    this.getUser();
  }

  logout() {
    const url = '';
    this.authenticationService.postLastUrl(url).subscribe();
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

  logoutInactiveTime(){
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

  getUser() {
    this.authenticationService.currentUser.subscribe(currentUser => {
      if (currentUser) {
        this.currentUser = currentUser;
        const endDateTime = new Date(this.currentUser.expires)
        const initialDateTime = new Date();
  
        this.expires =  (endDateTime.getTime() - initialDateTime.getTime())/1000;
      }
    });
  }
}
